var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg101(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "101") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-night",
    transform: "translate(-25.000000, -6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 101,
    transform: "translate(35.314577, 16.375618)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#BEE4F8",
    cx: 10.0428468,
    cy: 10.0399543,
    rx: 10.0428468,
    ry: 10.0399543
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60292571,15.4836779 C3.17213922,16.4985351 5.04256831,17.0877008 7.05063896,17.0877008 C12.5971948,17.0877008 17.0934857,12.5926068 17.0934857,7.04774649 C17.0934857,5.04127169 16.504719,3.17223896 15.4904603,1.60392312 C18.2556592,3.39226597 20.0856935,6.50246649 20.0856935,10.0399543 C20.0856935,15.5848145 15.5894026,20.0798088 10.0428468,20.0798088 C6.50336416,20.0798088 3.39156779,18.2493756 1.60292571,15.4836779 Z",
    id: "Path",
    fill: "#7CCDF9",
    opacity: 0.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg101);
export default __webpack_public_path__ + "static/media/101.d88901363b15ab9be11e3706ee2bad2d.svg";
export { ForwardRef as ReactComponent };